// This is the providers wrapper. Add any additional providers in the chain here.
import React from "react";

import { ReduxProvider } from "../ReduxProvider";

export const Provider: React.FC = ({ children }) => <ReduxProvider>{children}</ReduxProvider>;
